import React, { Suspense, ReactNode } from 'react';
import PageLoader from '../ui/PageLoader';

interface LazyRouteProps {
  children: ReactNode;
}

export default function LazyRoute({ children }: LazyRouteProps) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}
